import {createRouter, createWebHistory} from "vue-router";
import CheckoutPage from "@/checkout/pages/CheckoutPage.vue";
import CheckoutCompletePage from "@/checkout/pages/CheckoutCompletePage.vue";
import GuestTestPage from "@/checkout/pages/GuestTestPage.vue";
import FormTesterPage from "@/checkout/pages/FormTesterPage.vue";

const routes = [
    {
        name: 'testFormPage',
        path: '/form-test',
        component: FormTesterPage,
        props: true
    },
    {
        name: 'testGuestStarter',
        path: '/guest-starter',
        component: GuestTestPage,
        props: true
    },
    {
        name: 'checkout',
        path: '/:checkoutId',
        component: CheckoutPage,
        props: true
    },
    {
        name: 'checkout-complete',
        path: '/:checkoutId/complete',
        component: CheckoutCompletePage,
        props: true
    }
]

const router = createRouter({
    routes: routes,
    history: createWebHistory(process.env.APP_BASE_PATH),
});

export default router;